'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = IntersectWeeklyAvailabilities;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _intervalUtils = require('interval-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function IntersectWeeklyAvailabilities(a1, a2) {
    var a1Weekly = availabilityToWeekly(a1);
    var a2Weekly = availabilityToWeekly(a2);

    if (!_lodash2.default.size(a1Weekly) && _lodash2.default.size(a2Weekly)) return a2;

    if (!_lodash2.default.size(a2Weekly) && _lodash2.default.size(a1Weekly)) return a1;

    var i1 = weeklyAvailabilityToIntervals(a1Weekly);
    var i2 = weeklyAvailabilityToIntervals(a2Weekly);

    var intersection = (0, _intervalUtils.intersectIntervals)(i1, i2);
    var intersectionAvailability = intervalsToAvailability(intersection);
    return intersectionAvailability;
}

function availabilityToWeekly(availability) {
    return availability ? availability.weekly : [];
}

function weeklyAvailabilityToIntervals(weekly) {
    return _lodash2.default.map(weekly, availabilityRangeToInterval);
}

function availabilityRangeToInterval(_ref) {
    var minuteOfWeek = _ref.minuteOfWeek,
        durationMins = _ref.durationMins;

    return [minuteOfWeek, minuteOfWeek + durationMins];
}

function intervalsToAvailability(intervals) {
    var durations = _lodash2.default.map(intervals, function (i) {
        return {
            minuteOfWeek: i[0],
            durationMins: i[1] - i[0]
        };
    });

    return { weekly: durations };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/availability/dist/utils/intersectWeeklyAvailabilities.js
// module id = 681
// module chunks = 0